<div class="modal-header">
  <h4 class="modal-title">Contact Support</h4>
  <button class="shadow-none close-btn" (click)="onClose()">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#5E5E5E" viewBox="0 0 384 512">
      <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
    </svg>
  </button>
</div>
<div class="modal-body">
  <p>
    To downgrade your plan, please contact our support team. They will assist you with the process and answer any
    questions you may have.
  </p>
  <p>{{ 'Email: support@musaffa.com' }}</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="onClose()">Close</button>
</div>


